import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TrackingProperties } from '../scorecard';
import { MatButton } from '@angular/material/button';
import { ProductAnalyticsModule } from '@vendasta/product-analytics';
import { NgIf } from '@angular/common';
import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'snap-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss'],
  imports: [MatButton, ProductAnalyticsModule, NgIf, CdkCopyToClipboard, MatIcon, TranslateModule],
})
export class ActionsComponent {
  @Input() snapshotURL: string;
  @Input() trackingProperties: TrackingProperties;
  @Input() enableURLCopy = false;
  @Input() showEditButton = false;

  @Output() viewSnapshotClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() editSnapshotClicked: EventEmitter<void> = new EventEmitter<void>();

  viewSnapshot(): void {
    this.viewSnapshotClicked.emit();
  }

  editSnapshot(): void {
    this.editSnapshotClicked.emit();
  }
}
